import {Link} from 'react-router-dom';
import {ArrowLeftOutlined} from '@ant-design/icons';

import Table from '../../components/ui/Table';
import {forecastedInvoicesTableConfig} from './configs/forecastedInvoicesTableConfig';

const ForecastedInvoicesPage = ({
    data,
    userData,
    filterForecastedInvoicesList,
    tableType,
    paginationMetadata,
    onPageNumberChange,
    tableLoading
}) => {
    const tableConfig = forecastedInvoicesTableConfig(
        userData,
        filterForecastedInvoicesList,
        tableType
    );

    return (
        <>
            <div className='flex items-center justify-between pt-10 pb-5'>
                <Link to='/dashboard/admin'>
                    <ArrowLeftOutlined style={{fontSize: '25px'}}/>
                </Link>
                <h1
                    className='text-3xl font-bold'
                    style={{fontFamily: 'DIN Condensed'}}
                >
                    {`Factures prévisionnelles (${paginationMetadata.totalItems})`}
                </h1>
                <div/>
            </div>
            <Table
                data={data}
                tableConfig={tableConfig}
                paginationMetadata={paginationMetadata}
                onPageNumberChange={onPageNumberChange}
                loading={tableLoading}
            />
        </>
    )
}

export default ForecastedInvoicesPage;
